import { Width } from 'state/product-description/types';

export function getEssentialNodeClassName(width?: Width) {
  switch (width) {
    case 'half':
      return 'g-col-12 g-col-md-6';
    case 'third':
      return 'g-col-12 g-col-md-4';
    case 'quarter':
      return 'g-col-12 g-col-md-3';
    case 'sixth':
      return 'g-col-12 g-col-md-2';
    default:
      return 'g-col-12';
  }
}
